module.exports = __webpack_public_path__ + "static/media/Zero-Risk Bias.3099aeec.jpg";